import { Injectable } from '@angular/core';
import { AwsService } from '../../providers/appsyncservice/aws.service';

@Injectable({
  providedIn: 'root'
})
export class UserDetailsService {

  private userdetails: any = [];
  constructor(public aws: AwsService) { }

  private async getUserDetailsByUserName(username: String) {
    let result = await this.aws.rnUserFilter(username.toUpperCase());
    if (result.length > 0) {
      return result[0];

    }

  }

  public async getDetails(username: String): Promise<IUser> {
    //   console.log("userdetails",this.userdetails,this.userdetails[username.toUpperCase()]);
    if (this.userdetails[username.toUpperCase()] == undefined) {
      let val: IUser = await this.getUserDetailsByUserName(username);
      this.userdetails[username.toUpperCase()] = val;
      return val;
    }
    return this.userdetails[username.toUpperCase()];
  }


}
export interface IUser {
  id: string;
  employee_phone: string;
  email_address: string;
  name: string;
  user_name: string;
  user_type?: number;
}

